import moment from 'moment';

/**
 * Formats any date string to YYYY-MM-DD in the user's local timezone.
 */
export const dateStringToYYYYMMDD = (dateString) => {
    if (!dateString) return null;
    
    // .format() defaults to local time
    return moment(dateString).format('YYYY-MM-DD');
};

/**
 * Formats any date string to DD-MM-YYYY in the user's local timezone.
 * (Note: Your function is named ...YYYYMMDD but returns DD-MM-YYYY,
 * so this implementation keeps your original DD-MM-YYYY format).
 */
export const isoDateStringToYYYYMMDD = (isoDateString) => {
    if (!isoDateString) return null;

    // .format() defaults to local time
    return moment(isoDateString).format('DD-MM-YYYY');
};

/**
 * Formats any date string to DD-MM-YYYY HH:mm:ss in the user's local timezone.
 */
export const isoDateStringToYYYYMMDDhhmmss = (isoDateString) => {
    if (!isoDateString) return null;

    // .format() defaults to local time
    return moment(isoDateString).format('DD-MM-YYYY HH:mm:ss');
};

export const convertRoutePathToLink = (routePath) => {
    return '/' + routePath.replace('/*', '');
};
